import React from "react";
import Input from "../../atoms/Input";

const SpecificTimePeriod = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}) => {
  return (
    <div>
      <div className="flex gap-8">
        <div>
          <label htmlFor="startDate" className="text-xs text-gray-500">
            From
          </label>
          <Input
            type="date"
            variant="secondary"
            className="w-40 pt-4 text-lg"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <p className="text-gray-500 my-auto text-lg pt-10">-</p>
        <div>
          <label htmlFor="endDate" className="text-xs text-gray-500">
            To
          </label>
          <Input
            type="date"
            variant="secondary"
            className="w-40 pt-4 text-lg"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SpecificTimePeriod;
